export default {
  GET_VARIANTS: (state) => state.variants,
  GET_VARIANT: (state) => state.variant,
};
